<template>
    <div>
        <el-breadcrumb separator="/" class="bread">
            <el-breadcrumb-item :to="{ name: 'pro' }">我的商品</el-breadcrumb-item>
            <el-breadcrumb-item>维护商品</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card header="基本信息">
            <el-form :model="Product.Data" :rules="Productrules" ref="Product" label-width="200px" label-position="left" class="demo-ruleForm">
                <el-form-item label="商品编码" prop="SKU">
                    <el-input v-model="Product.Data.SKU" placeholder="请输入商品编码"></el-input>
                </el-form-item>
                <el-form-item label="商品名称" prop="Name">
                    <el-input v-model="Product.Data.Name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="商品分类">
                    <el-cascader expand-trigger="hover" clearable :options="Cate" v-model="selectedCate"></el-cascader>
                </el-form-item>
                <el-form-item label="商品规格/型号">
                    <el-input v-model="Product.Data.Model" placeholder="请输入商品规格/型号"></el-input>
                </el-form-item>
                <el-form-item label="品牌">
                    <el-input v-model="Product.Data.Brand" placeholder="请输入品牌"></el-input>

                </el-form-item><el-form-item label="加盟商">
                    <el-input v-model="Product.Data.franchise" placeholder="请输入加盟商"></el-input>
                </el-form-item>
                <el-form-item label="商品价格(元)" prop='Price'>
                    <el-input v-model="Product.Data.Price" placeholder="请输入商品价格"></el-input>
                </el-form-item>
                <el-form-item label="商品条形码" prop='UPC'>
                    <el-input v-model="Product.Data.UPC" placeholder="请输入商品条形码"></el-input>
                </el-form-item>
                <el-form-item label="商品图片" label-for="fileInputMulti" :label-cols="3" :horizontal="true">
                    <img :src="imageUrl" style="width:100px;"></img>
                    <input type="file" @change="getFile($event)">
                </el-form-item>
            </el-form>

            <el-form label-width="200px" label-position="left" class="demo-ruleForm">
                <el-form-item label="商品简介">
                    <el-input v-model="Product.Data.Description" placeholder="请输入商品简介" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item label="图文详情">
                    <vue-editor useCustomImageHandler @imageAdded="handleImageAdded" v-model="Product.Data.DescriptionHtml"></vue-editor>
                </el-form-item>
            </el-form>
        </el-card>
            <el-card header="自定义参数配置">
                <el-form >
                    <el-row v-for="(item,key,index) in CustomParams" :key="key">
                        <el-col >
                            <el-form-item>
                                <el-input type="text" :placeholder="item.key" v-model="item.key" style="width: 20%;"></el-input>

                                <el-input type="text" :placeholder="item.value" v-model="item.value" style="width: 40%;margin-left: 3%;"></el-input>

                                <el-button variant="warning" class="m-0" size="small" @click="removeConf(index)"
                                           style="margin-left: 3%;background-color: #ffc107">&nbsp删除</el-button>
                            </el-form-item>

                        </el-col>

                    </el-row>
                    <div >
                        <el-button style="background-color: #20a8d8;color: #fff"  size="small"
                                   type="submit" variant="warning" @click="addConfig">新增</el-button>
                    </div>
                </el-form>
            </el-card>
            <el-card header="取货模式">
                <el-form label-width="200px" label-position="left" class="demo-ruleForm">
                    <el-form-item v-for="(item,key,index) in Product.Data.FetchParams" :label="FetchModel(key)" label-for="basicSelect"
                                  :key="key" :label-cols="3" :horizontal="true">
                        <el-radio-group v-show="key === 'FetchSpeed'" v-model="Product.Data.FetchParams.FetchSpeed">
                            <el-radio :label=1>高速</el-radio>
                            <el-radio :label=0>常速</el-radio>
                            <el-radio :label=2>低速</el-radio>
                        </el-radio-group>
                        <el-radio-group v-show="key === 'FetchStyle'" v-model="Product.Data.FetchParams.FetchStyle">
                            <el-radio label='low'>低位</el-radio>
                            <el-radio label='mid'>中位</el-radio>
                            <!-- <el-radio :label=''>高位</el-radio> -->
                        </el-radio-group>
                        <span v-show="key === 'FetchDelay'">
                <el-input-number v-model="Product.Data.FetchParams.FetchDelay" :step="10"
                                 controls-position="right"></el-input-number> x10 = {{Product.Data.FetchParams.FetchDelay*10}}毫秒</span>
                        <span v-show="key === 'FetchPreDelay'">
                <el-input-number v-model="Product.Data.FetchParams.FetchPreDelay" :step="10"
                                 controls-position="right"></el-input-number> x10 = {{Product.Data.FetchParams.FetchPreDelay*10}}毫秒</span>
                        <span v-show="key === 'FetchDuration'">
                <el-input-number v-show="key === 'FetchDuration'" v-model="Product.Data.FetchParams.FetchDuration" :step="10"
                                 controls-position="right"></el-input-number> x5 = {{Product.Data.FetchParams.FetchDuration*5}}毫秒</span>
                        <el-radio-group v-show="key === 'TrayType'" v-model="Product.Data.FetchParams.TrayType">
                            <el-radio label="raw">无托盘</el-radio>
                            <el-radio label="tray">有托盘</el-radio>
                        </el-radio-group>
                        <el-radio-group v-show="key === 'TrayCount'" v-model="Product.Data.FetchParams.TrayCount">
                            <el-radio v-for="(item) in [0,1,2,3,4]" :key='item' :label="item">{{item}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </el-card>
        <div style="margin-top: 2%">
            <el-button type="submit" style="background-color: #20a8d8;color: #fff" size="small" variant="primary" @click="save">
                <i class="fa fa-dot-circle-o"></i> 保存</el-button>
            <el-button type="reset" size="small" variant="danger" style="background-color: #f64846;color: #fff" @click="cancleBack">
                <i class="fa fa-ban"></i> 撤销并返回</el-button>
        </div>
    </div>

</template>
<script>
    import axios from 'axios'// 引入axios
    import {VueEditor} from 'vue2-editor'
    import ElFormItem from "../../../../node_modules/element-ui/packages/form/src/form-item.vue";
    import SparkMD5 from 'spark-md5'

    export default {
        components: {
            ElFormItem,
            VueEditor
        },
        data() {
            var checkPrice = (rule, value, callback) => {
                var priceReg = new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.[1-9]{1,1})([0-9]{0,1})$)|(^0(\.[0-9]{1,1})([1-9]{1,1})$)/i);
                if (!priceReg.test(value)) {
                    return callback(new Error('请输入正确价格'));
                } else {
                    callback();
                }
            };
            var validateProSKU = (rule, value, callback) => {
                    this.validateFlag = true;
                    if(this.validateSKU != value){
                        if (value === '') {
                            callback(new Error('请输入商品编码！'));
                        } else {
                            this.$http.get(this.productURL+"/vueFeign/validate/proSKU",{params:{"tenantId":this.getcookie('storeId'),"SKU":value}}).then(response => {
                                if (response.status === 200) {
                                    if (response.body.Code === "201"){
                                        this.validateFlag = false;
                                        callback(new Error('商品编码已存在请重新输入！'));
                                    }else if(response.body.Code === "200"){
                                        callback();
                                    }else {
                                        this.$message({
                                            showClose: true,
                                            message: '网络异常',
                                            type: 'error'

                                        });
                                    }
                                }
                            },function(response){
                                this.$message({
                                    showClose: true,
                                    message: '网络异常',
                                    type: 'error'

                                });
                            })
                        }
                    }else {
                        callback();
                    }
            };
            return {
                priceVili: true,
                validateFlag: true,
                validateSKU: "",
                image: '',
                imageUrl: '',
                sellingPrice: 0,
                CustomParams: [],
                Cate: [],
                selectedCate: [],
                ProStatus: '下架',
                skuerr:'input_error',
                Productrules: {
                    SKU: [
                        { required: true, message: '请输入商品编码', trigger: 'blur' },
                        { validator: validateProSKU, trigger: 'blur' },
                    ],
                    Name: [
                        { required: true, message: '请输入商品名称', trigger: 'blur' },
                    ],
                    Price: [
                        { required: true, message: '请输入正确商品价格', validator: checkPrice, trigger: 'blur' },
                    ],
                    UPC: [
                        { required: true, message: '请输入商品条形码', trigger: 'blur' },
                    ],
                },
                str:[],
                Product: {
                    Data: {
                        UPC: '',
                        Name: '',
                        Price: '',
                        franchise:'',
                        Image: {
                            Height: 0,
                            ID: '',
                            Md5: '',
                            Size: 0,
                            Type: '',
                            Url: '',
                            Width: 0
                        },
                        Brand: '',
                        Model: '',
                        Description: '',
                        DescriptionHtml: '',
                        PhysicalParams: {
                            'Shape': '',
                            'Transparent': '',
                            'Height': '',
                            'Width': '',
                            'Depth': '',
                            'Weight': ''
                        },
                        FetchParams: {
                            'FetchStyle': 'low',
                            'FetchSpeed': 0,
                            'FetchDelay': 0,
                            'FetchPreDelay': 5,
                            'FetchDuration': 20,
                            'TrayCount': 0,
                            'TrayType': 'raw'
                        },
                        SKU: '',
                        Priority: 100,
                        CustomParams: {},
                        Categories: [],
                        ShelfLife: 10000,
                        LoadSuggestion: {
                            'Desc': '',
                            'Url': ''
                        },
                    },
                }
            };
        },
        watch: {
            image: function (newQuestion, oldQuestion) {
                let reader = new FileReader()
                reader.readAsDataURL(this.image[0])
                let that = this
                reader.onload = function () {
                    that.imageUrl = this.result
                }
            },
        },
        created(){
            if (this.$route.query.data != undefined) {
                this.validateSKU  = this.$route.query.data.SKU;
                let fetchOfProduct = this.$route.query.data
                console.log("fetchOfProduct", fetchOfProduct)

                var pro = this.$route.query.data
                console.log(pro)
                if (!fetchOfProduct.fetchStyle) {
                    this.Product.Data.FetchParams.FetchStyle = 'low'
                }
                console.log(pro)
                this.Product.Data.Price = (pro.price / 100).toFixed(2);
                this.Product.Data.UPC = pro.UPC;
                this.Product.Data.Name = pro.productName;
                this.Product.Data.franchise = pro.franchise;
                this.Product.Data.franchise = pro.franchise;
                this.Product.Data.Image.Url = pro.Image;
                this.Product.Data.Brand = pro.brand;
                this.Product.Data.Model = pro.model;
                this.Product.Data.Description = pro.description;
                this.Product.Data.DescriptionHtml = pro.descriptionHtml;
                this.Product.Data.SKU = pro.SKU;
                this.Product.Data.FetchParams.FetchDelay = pro.fetchDelay;
                this.Product.Data.FetchParams.FetchDuration = pro.fetchDuration;
                this.Product.Data.FetchParams.FetchPreDelay = pro.fetchPreDelay;
                this.Product.Data.FetchParams.FetchSpeed = pro.fetchSpeed;
                this.imageUrl = this.fusionImageUrl + pro.Image
                this.ProStatus = pro.status == '1' ? '上架' : '下架'
                this.str = pro.categories.replace(/\"/g, "");
                console.log(this.str);
                var split = this.str.split(',')
                console.log(split);
                if(this.str != ''){
                    for (var i=0;i<split.length;i++){
                        var categories = split[i].match(/[a-zA-Z0-9]{6,16}/)
                        console.log(categories[0])
                        this.selectedCate.push(categories[0])
                    }
                }

            }
            this.getCate()
        },
        methods: {
            FetchModel: function (key) {
                switch (key) {
                    case 'FetchSpeed' : {
                        return '取货齿轮转速'
                        break
                    }
                    case 'FetchStyle' : {
                        return '取货平台高度'
                        break
                    }
                    case 'FetchDelay' : {
                        return '取货后置延迟'
                        break
                    }
                    case 'FetchPreDelay' : {
                        return '取货前置延迟'
                        break
                    }
                    case 'FetchDuration' : {
                        return '取货感应延时'
                        break
                    }
                    case 'TrayCount' : {
                        return '槽位格数(M系列)'
                        break
                    }
                    case 'TrayType' : {
                        return '槽位类型(M系列)'
                        break
                    }
                    default : {
                        break
                    }
                }
            },
            getFile(event){
                this.image=event.target.files;
            },
            getCate: function () {
                var params = {tenantId:this.getcookie('storeId')};
                this.$http.get(this.productURL+"/vueFeign/category",{params:params}
                ).then(res => {
                    if (res.status === 200) {
                      if (res.data.Code == '200') {
                        var li = res.data.Data.Category
                        for (var i = 0; i < li.length; i++) {
                            var item = li[i]
                            item.label = item.categoryName
                            item.value = item.categoryId
                            if (item.Children != null && item.Children.length > 0) {
                                for (var j = 0; j < item.Children.length; j++) {
                                    var child = item.Children[j]
                                    child.label = child.categoryName
                                    child.value = child.categoryId
                                }
                            }
                            item.children = item.Children
                        }
                        this.Cate = li
                    } else {
                        // this.$message.error('数据获取失败，异常：' + res.data.Meta)
                    }
                    }else{
                        this.$message.error('未找到符合条件的数据')
                        this.items = []
                    }
                },function(response){
                    this.items = []
                    this.$message({
                        showClose: true,
                        message: '网络异常',
                        type: 'error'
                    });
                })
            },
            vilisku() {
                console.log('1234567')
                if(Product.Data.SKU === ''){
                    this.skuerr = 'input_error'
                }
            },
            addConfig: function () {
                this.CustomParams.push({key: '新增', value: '请输入配置项'})
            },
            removeConf: function (index) {
                this.CustomParams.splice(index, 1)
            },
            save() {
                if (this.image != '') {
                    var reader = new FileReader()
                    reader.readAsBinaryString(this.image[0])
                    let that = this
                    reader.onloadend = function (e) {
                        let contents = e.target.result
                        let spark = new SparkMD5()
                        spark.appendBinary(contents)
                        var base64MD5String = new Buffer(spark.end(), 'hex').toString('base64');
                        debugger
                        var ma5Str = base64MD5String.replace(/\+/, "%2B");
                        axios({
                            method: 'post',
                            url: that.productURL+"/vueFeign/signedURL?Token=01CZFCJ0XKSMGE8MD1156DBYKZ&MD5="+ma5Str,
                        }).then(function(response) {
                            if (response.status === 200) {
                                if(response.data.Code = '200'){
                                    let resp = response.data.Data
                                    that.updateProImages(resp.SignedURL, that.image[0], resp.Headers);
                                    that.Product.Data.Image.ID = resp.FileID;
                                    that.Product.Data.Image.Url = resp.FilePath;
                                    that.Product.Data.Image.Type = resp.Type;
                                    that.savePro();
                                }else {
                                    that.$message.error('图片添加失败，异常：' + response.data.Meta)
                                }
                            }
                        });
                    }
                } else {
                    this.savePro()
                }
            },
            updateProImages: function (url, data, headers) {
                const instance = axios.create({
                    headers: headers,
                    timeout: 30 * 1000 // 30秒超时
                })
                let options = {
                    url: url,
                    method: 'PUT',
                    data: data
                }
                instance(options)
                    .then(response => {
                        console.log(response.data)
                    })
                    .catch(error => {
                        console.log('请求异常信息：' + error)
                    })
            },
            cancleBack: function () {
                history.go(-1)
            },
            savePro: function () {
                if(this.validateFlag){
                    var tmp = {}
                    for (var i = 0; i < this.CustomParams.length; i++) {
                        var item = this.CustomParams[i]
                        if (item.key != '新增') {
                            tmp[item.key] = item.value
                        }
                    }
                    if (!this.vilidate()) {
                        return
                    }
                    this.Product.Data.CustomParams = tmp
                    if (this.$route.query.cmd == 'add') {
                        this.Product.Data.Price = parseInt((this.Product.Data.Price * 100).toFixed(0))
                        this.Product.Data.Categories = this.selectedCate
                        var that = this;
                        axios({
                            method: 'post',
                            url: this.productURL+"/vueFeign/product/add",
                            data: {
                                Product:this.Product.Data,
                                tenantId:this.getcookie('storeId'),
                            }
                        }).then(function(response) {
                            if (response.status === 200) {
                                if (response.data.Code == '200') {
                                    that.$message.success('商品新增成功！')
                                    that.fusionProAdd(response.data.proId);
                                    setTimeout(() => history.go(-1), 2000)
                                } else {
                                    that.$message.error('数据获取失败，异常：' + response.data.Meta)
                                    that.Product.Data.Price = that.Product.Data.Price / 100
                                }
                            }
                        });

                    } else if (this.$route.query.cmd == 'edit') {
                        this.Product.Data.Price = parseInt((this.Product.Data.Price * 100).toFixed(0))
                        this.Product.Data.Categories = this.selectedCate;
                        console.log(this.Product)
                        var that = this;
                        axios({
                            method: 'post',
                            url: this.productURL+"/vueFeign/product/Update",
                            data: {
                                Product:that.Product.Data,
                                tenantId:that.getcookie('storeId'),
                                productId:that.$route.query.data.productId
                            }
                        }).then(function(response) {
                            if (response.status === 200) {
                                if (response.data.Code == '200') {
                                    that.$message.success('商品编辑成功！')
                                    that.fusionProUpdate(that.$route.query.data.productId);
                                    setTimeout(() => history.go(-1), 2000)
                                } else {
                                    that.$message.error('数据获取失败，异常：' + response.data.Meta)
                                }
                            }
                        });
                    }
                }
            },
            fusionProAdd(proId){
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/fusion/proAdd?tenantId="+that.getcookie('storeId')+"&proId="+proId,
                }).then(function(response) {
                    if (response.status === 200) {
                        if (response.data.Code == '200') {

                        } else {
                            that.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
            fusionProUpdate(proId){
                var that = this;
                axios({
                    method: 'post',
                    url: this.productURL+"/vueFeign/fusion/proUpdate?tenantId="+that.getcookie('storeId')+"&proId="+proId,
                }).then(function(response) {
                    if (response.status === 200) {
                        if (response.data.Code == '200') {

                        } else {
                            that.$message.error('数据获取失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
            vilidate: function () {
                if (!this.Product.Data.SKU) {
                    this.$message.error('请输入商品编码')
                    return
                }
                if (!this.Product.Data.Name) {
                    this.$message.error('请输商品名称')
                    return
                }
                var patt1 = new RegExp(/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.[1-9]{1,1})([0-9]{0,1})$)|(^0(\.[0-9]{1,1})([1-9]{1,1})$)/i);
                console.log('result : '+ patt1.test(this.Product.Data.Price))
                if (!patt1.test(this.Product.Data.Price)) {
                    this.priceVili = false
                    this.$message.error('请输入正确的商品价格')
                    return
                }else{
                    this.priceVili = true
                }
                if (!this.Product.Data.UPC) {
                    this.$message.error('请输入正确的商品条形码')
                    return
                }
                return true
            },
            handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
                let reader = new FileReader()
                reader.readAsBinaryString(file)
                let that = this
                reader.onloadend = function (e) {
                    let contents = e.target.result
                    let spark = new SparkMD5()
                    spark.appendBinary(contents)
                    let base64MD5String = new Buffer(spark.end(), 'hex').toString('base64')
                    var ma5Str = base64MD5String.replace(/\+/, "%2B");
                    that.getUpdateUrl(ma5Str, file, file.type, Editor, cursorLocation)
                }
            },
            getUpdateUrl: function (md5, binary, type, Editor, cursorLocation) {
                var that = this;
                axios({
                    method: 'post',
                    url: that.productURL+"/vueFeign/signedURL?Token=01CZFCJ0XKSMGE8MD1156DBYKZ&MD5="+md5,
                }).then(function(response) {
                    if (response.status === 200) {
                        if(response.data.Code = '200'){
                            let resp = response.data.Data
                            that.updateImages(resp.SignedURL, binary, resp.Headers, Editor, cursorLocation, response.data.Data.FilePath)
                        }else {
                            that.$message.error('图片添加失败，异常：' + response.data.Meta)
                        }
                    }
                });
            },
            updateImages: function (url, data, headers, Editor, cursorLocation, FilePath) {
                const instance = axios.create({
                    headers: headers,
                    timeout: 30 * 1000 // 30秒超时
                })
                let options = {
                    url: url,
                    method: 'PUT',
                    data: data
                }
                instance(options)
                    .then(response => {
                        console.log(response.data)
                        Editor.insertEmbed(cursorLocation, 'image', this.fusionImageUrl + FilePath);
                    })
                    .catch(error => {
                        console.log('请求异常信息：' + error)
                    })
            }
        },
        computed: {
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        }
    };
</script>
<style>
    .input_error {
        border: 1px solid red
    }
</style>


// WEBPACK FOOTER //
// editPro.vue?56a33b44